import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const SirkaDisku = {
	name: NAME,
	apiProvider,
	router,
};
